import styled from 'styled-components';
import { colors, MediaQuery } from '../../theme/style-helpers';

export const Icon = styled.img`
  transform: rotate(0);
  transition: all 0.3s;
  cursor: pointer;
  width: 16px;
  height: 20px;
`;

export const FilterContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  background: ${colors.WHITE};
  box-sizing: border-box;
  font-style: normal;
  font-weight: 500;
  font-size: 1.8rem;
  line-height: 2.4rem;

  ${MediaQuery.medium`
    display: flex;
    flex-direction: column;
    margin: 0;
  `};

  ${MediaQuery.large`
    flex-direction: row;
  `};

  .search-filter {
    margin: 0;
  } 

  .items-max-width {
    display: flex;
    flex-direction: column;
    padding: 0;
    gap: 20px;

    ${MediaQuery.medium`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: baseline;
    `};
  }

  .dropdown-companies {
    width: 100%;

    ${MediaQuery.medium`
      width: 50%;
      margin-bottom: 0;
      margin-top: 0;
    `}
  }

  .add-user-button {

  }
`;

export const PageTitleH1 = styled.h1`
  font-size: 28px;
  font-weight: 500;
  line-height: 36px;
  letter-spacing: 0em;
  margin: 0 0 16px 0;

  ${MediaQuery.small`
    font-size: 3.6rem;
    font-weight: 500;
    line-height: 47px;
  `}
`;

export const PageDescription = styled.div`
  line-height: 21px;
  font-size: 14px;

  ${MediaQuery.medium`
    font-size: 16px;
    line-height: 24px;
  `}
`;

export const ModalTitle = styled.div`
  font-size: 2.5rem;
  padding-bottom: 25px;
`;

export const Close = styled.div`
  position: absolute;
  right: 32px;
  top: 32px;
  width: 32px;
  height: 32px;
  opacity: 0.3;
  cursor: pointer;

  &:hover {
    opacity: 1;
  }

  &:before,
  &:after {
    position: absolute;
    left: 15px;
    content: " ";
    height: 33px;
    width: 2px;
    background-color: #333;
  }

  &:before {
    transform: rotate(45deg);
  }

  &:after {
    transform: rotate(-45deg);
  }
`;

export const ModalBody = styled.div`
  padding: 50px;
  font-size: 1.5rem;
  text-align: center;
`;

export const ButtonDiv = styled.div`
  padding-top: 32px;
  display: flex;
  justify-content: center;
  gap: 16px;
`;

export const SuccessDeleteMessage = styled.div`
  font-family: Montserrat;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  display: flex;
  align-items: center;
  color: ${colors.LAND_GREEN};
`;

export const ActionsContainer = styled.div`
  display: flex;
  margin-top: 20px;

  ${MediaQuery.medium`

  `};

  ${MediaQuery.large`
    padding-left: 80px; 
  `}
`;

export const FiltersAndTableContainer = styled.div`
  display: grid;
  grid-auto-flow: row;
  grid-gap: 32px;
`;

export const TableContainer = styled.div`
  font-size: 14px;
  margin-bottom: 56px;

  table {

  thead {
        
    tr {
      background-color: #F2F2F2;
      cursor: pointer;
    }

    th {
      border-bottom: 0;
    }

    th:first-child {
      padding: 16px;
    }

    p {
      font-weight: 500;
    }

  }

  tbody {
  
  p:last-child {
    padding: 16px;
  }

  tr:nth-child(even) {
    background-color: #ffffff !important;
  }

  tr {
    border-bottom: 1px solid rgb(217, 217, 214);
  }

  td:first-child {
    padding: 16px !important;
  }

    li {
    color: rgb(0, 0, 0);
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;

    &.active {
      font-weight: 100;
      width: 100px;
    }
  }
}
}

.dropdown {
    .btn{
      padding: 0 !important;
    }

    .dropdown-menu {
        background-color: rgb(249, 249, 249) !important;
        border: 1px solid rgba(0, 0, 0, .15) !important;

        .dropdown-item {
          color: rgb(0, 0, 0) !important;
        }
    }

    .div {
      background-color: red;
    }
}
`;

export const PaginationContainer = styled.div`
    width: 100%;
    margin: 45px 0;
    
    ul {
        display: flex;
        flex-wrap: wrap;
        gap: 32px;
        justify-content: center;
        padding: 0;
        margin: 0;
        list-style: none;

        li {
            padding: 1rem 1.5rem;
            font-size: 16px;
            font-weight: 500;
  
            &.active {
                font-size: 16px !important;
                font-weight: 700 !important;
                border-bottom: 2px solid rgb(255, 95, 20);
                text-decoration: none !important;
            }
        }
    }
`;

export const SearchContainer = styled.div`
  position: relative;
  display: grid;
  grid-auto-flow: row;
  row-gap: 8px;
  grid-auto-rows: max-content;
`;

export const SearchLabel = styled.label`
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  margin: 0;
`;
